import { render } from "./QVPKidsExamCenterList.vue?vue&type=template&id=d5ef4f36&scoped=true"
import script from "./QVPKidsExamCenterList.vue?vue&type=script&lang=js"
export * from "./QVPKidsExamCenterList.vue?vue&type=script&lang=js"

import "./QVPKidsExamCenterList.vue?vue&type=style&index=0&id=d5ef4f36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5ef4f36"]])

export default __exports__